/*
 * The Private License
 *
 * Copyright (c) 2023 Mahon Media LLC.
 */

import React from "react";
import {Checkbox, InputLabel, ListItemIcon, ListItemText, MenuItem, Select,} from "@mui/material";

import {MenuProps, useStyles} from "../utils/selectStyles";

export default function CustomMultipleSelect({
  selectedValue,
  setSelectedValue,
  options,
  label,
  isFullWidth = false,
  handleSelectValue,
  labelId,
}) {
  const classes = useStyles();

  const isAllSelected =
    options.length > 0 && selectedValue.length === options.length;

  const handleChange = (event) => {
    const value = event.target.value;

    if (value[value.length - 1] === "all") {
      setSelectedValue(selectedValue.length === options.length ? [] : options);
      return;
    }
    setSelectedValue(value);
  };

  return (
    <>
      <InputLabel sx={{ mt: "10px" }} id={labelId}>
        {label}
      </InputLabel>
      <Select
        labelId={labelId}
        multiple
        value={selectedValue}
        onChange={handleSelectValue || handleChange}
        fullWidth={isFullWidth}
        sx={{ mt: "10px" }}
        renderValue={(selectedValue) => selectedValue.join(", ")}
        MenuProps={MenuProps}
      >
        <MenuItem
          value="all"
          classes={{
            root: isAllSelected ? classes.selectedAll : "",
          }}
        >
          <ListItemIcon>
            <Checkbox
              classes={{ indeterminate: classes.indeterminateColor }}
              checked={isAllSelected}
              indeterminate={
                selectedValue.length > 0 &&
                selectedValue.length < options.length
              }
            />
          </ListItemIcon>
          <ListItemText
            classes={{ primary: classes.selectAllText }}
            primary="Select All"
          />
        </MenuItem>
        {options.map((option, index) => (
          <MenuItem key={Date.now() + index} value={option}>
            <ListItemIcon>
              <Checkbox checked={selectedValue.indexOf(option) > -1} />
            </ListItemIcon>
            <ListItemText primary={option} />
          </MenuItem>
        ))}
      </Select>
    </>
  );
}
